import { clearCoupon } from "./coupons";

const apiUrl = process.env.REACT_APP_API_URL || 'https://hutaoadmin.onrender.com/api';

const PLACE_ORDER = "cart/PLACE_ORDER";

const placeOrder = (cart) => ({
    type: PLACE_ORDER,
    cart
})

export const placeOrderThunkPayInStore = (
    id,
    paymentOption,
    name,
    phone,
    tip,
    customTip,
    address,
    cartItems,
    coupon,
    freeItem,
    x,
    scheduleTime,
    rewardItem,
    email,
    aptNumber,
    deliveryInstructions,
    bogoDeals,
    distanceText,
    specialItem,
    discountReward
) => async (dispatch) => {
    const response = await fetch(`${apiUrl}/neworders/main/${id}`, {
        method: 'POST',
        body: JSON.stringify({
            paymentOption,
            name,
            phone,
            tip,
            customTip,
            address,
            cartItems,
            coupon,
            freeItem,
            scheduleTime,
            rewardItem,
            email,
            aptNumber,
            deliveryInstructions,
            bogoItems: bogoDeals,
            delivery_range: distanceText,
            specialItem: specialItem || null,
            discountReward: discountReward || null,
            website_order: true,
        }),
        headers: {
            'Content-Type': 'application/json',
            credentials: 'include',
        },
        credentials: 'include',
    })

    if (response.ok) {
        const data = await response.json();
        dispatch(placeOrder(data))
        localStorage.removeItem('cart')
        localStorage.removeItem('freeItem')
        localStorage.removeItem('rewardItem')
        localStorage.removeItem(`discountReward-${id}`)
        dispatch(clearCoupon())
        return;
    }

    let message = `Order failed (${response.status})`;
    try {
        const err = await response.json();
        if (err?.message) message = err.message;
    } catch (_) { /* ignore */ }
    throw new Error(message);
}

const initialState = {
    cart: [],
    order: {}
};

const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case PLACE_ORDER:
            return {
                ...state,
                order: action.cart,
                cart: []
            };
        default:
            return state;
    }
};

export default orderReducer;
